import { render, staticRenderFns } from "./sold-price.vue?vue&type=template&id=bbba7370&scoped=true&"
import script from "./sold-price.vue?vue&type=script&lang=js&"
export * from "./sold-price.vue?vue&type=script&lang=js&"
import style0 from "./sold-price.vue?vue&type=style&index=0&id=bbba7370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbba7370",
  null
  
)

export default component.exports